<script>
import { Menu } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {
        items: []
      },
      redirectRoute: null
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Formset({
          modelPath: [this, 'form', 'items'],
          blankObject: { submenu_items: [] },
          items: this.form.items.map((item, i) => {
            return {
              headerLabel: get(item, ['link', 'label_en']),
              fields: [
                new fields.Link({
                  label: 'Link',
                  modelPath: [this, 'form', 'items', i, 'link']
                }),
                new fields.Formset({
                  header: 'Submenu',
                  modelPath: [this, 'form', 'items', i, 'submenu_items'],
                  items: item.submenu_items.map((submenu_item, j) => {
                    return {
                      headerLabel: get(submenu_item, ['link', 'label_en']),
                      fields: [
                        new fields.Link({
                          label: 'Link',
                          modelPath: [
                            this,
                            'form',
                            'items',
                            i,
                            'submenu_items',
                            j,
                            'link'
                          ]
                        })
                      ]
                    }
                  })
                })
              ]
            }
          })
        })
      ]
    }
  },
  computed: {
    service() {
      return Menu
    }
  }
}
</script>
